<info-page>
  <ng-template #image><img alt="" src="/assets/images/evaluation/expired.png" /></ng-template>
  <ng-template #title>Evaluation time period has expired</ng-template>
  <ng-template #description>
    You had eight weeks to evaluate the consultant - four weeks before the end of the contract and four weeks after the
    contract termination. If you have any questions, please
    @if (evaluationData?.ContactEmail) {
      <a href="mailto:{{ evaluationData?.ContactEmail }}">contact your 7N Agent</a>
    } @else {
      contact your 7N Agent
    }
    .
  </ng-template>
</info-page>
